export default {
  // created: function () {
  //   this.hello()
  // },
  data() {
    return {
      spinnerUrl: require("../../assets/spinner-1s-200px.gif"),
      height: 64,
      width: 64
    };
  }
};
